<template>
  <qx-card-form title="成本信息">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px"></qx-custom-form>
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      baseForm: {
        xxx5Options: [],
        inline: true,
        form: [
          {
            label: '载重油耗',
            value: 'oilCostPer',
            placeholder: '请输入载重油耗',
            type: 'input',
            unit: '升/百公里',
          },
          {
            label: '路桥费',
            value: 'pontagePer',
            placeholder: '请输入路桥费',
            type: 'input',
            unit: '元/百公里',
          },
          {
            label: '空载油耗',
            value: 'emptyOilCostPer',
            placeholder: '请输入空载油耗',
            type: 'input',
            unit: '升/百公里',
          },
        ],
      },
    };
  },
  methods: {

    async sub () {
      const formData = await this.handleSubData();
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          ...formData,
        };
      }
      return formData;
    },
    async init (data = {}) {
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
